import { cloneDeep, uniq, debounce, groupBy } from 'lodash';
import uniqid from 'uniqid';
import moment from 'moment';
import productAPi from '@/api/api_product';
import { getCalendarDay, calculatePrice } from '@/api/api_reserve';

function priceFormat(price) {
  return price ? price.toLocaleString() + '원' : '무료';
}

function getPersonKey(info, target, num) {
  if (info.samePrsnDiv) {
    //console.log(info.samePrsnDiv + '$' + target + '_' + num);
    return info.samePrsnDiv + '$' + target + '_' + num;
  } else {
    return info.pdNo + '$' + target + '_' + num;
  }
}

function getFlatPcnt(pcntList) {
  const allPcntList = pcntList.map((prePcnt) => {
    return prePcnt.expProduct.map((prod) => {
      const pcnt = {
        ...prePcnt,
        pdNo: prod.pdNo,
        scheSeqNo: prod.scheSeqNo,
        upperCd: prod.upperCd,
        exhpHzCd: prod.exhpHzCd,
      };
      delete pcnt.expProduct;
      return pcnt;
    });
  });

  return [].concat(...allPcntList);
}

function setPriceList(list, pcntYn, oldList) {
  if (pcntYn === 'Y') {
    if (oldList && oldList.length > 0) {
      return list.map((e, i) => ({ ...e, formatedPrice: '', pcnt: oldList[i].pcnt, disabled: true }));
    } else {
      return list.map((e) => ({ ...e, formatedPrice: '', disabled: true }));
    }
  } else {
    if (oldList && oldList.length > 0) {
      return list.map((e, i) => ({ ...e, formatedPrice: priceFormat(e.price), pcnt: oldList[i].pcnt, disabled: false }));
    } else {
      return list.map((e, i) => ({ ...e, formatedPrice: priceFormat(e.price), pcnt: 0, disabled: false }));
    }
  }
}

function setExphList(list, product, oldList) {
  const isPackage = product.mstrPdList.length > 1;
  const isMultiRound = list.length > 1;
  const bPcntYn = product.pcntYn === 'Y';
  let defaultOpen = true;

  let exphList = list.map((e, i) => {
    let exphListNm = isPackage ? e.pdDivNm : '체험실';
    if (isMultiRound) {
      exphListNm += `(${e.scheSeqNo} 회차, ${e.scheTm})`;
      defaultOpen = i === 0;
    }

    return {
      ...e,
      exphListNm,
      defaultOpen,
      exphTotPcnt: 0,
      maxTotPcnt: bPcntYn ? e.pcnt : -1,
    };
  });

  //체험 인원 유지
  if (oldList) {
    const orgExphList = cloneDeep(exphList);
    const isEqual = exphList.every((exph, i) => {
      let equal = true;
      const oldExph = oldList[i];
      let exphTotPcnt = 0;
      if (exph.pdNo === oldExph?.pdNo) {
        exph.roadList?.every((road, j) => {
          const oldRoad = oldExph.roadList[j];
          //다른 날짜/회차의 체험실이 같을 경우에만 pcnt 유지
          if (road.exhpHzCd === oldRoad?.exhpHzCd && road.exphList.length === oldRoad.exphList?.length) {
            for (let k = 0; k < road.exphList.length; k++) {
              if (road.exphList[k].upperCd === oldRoad.exphList[k]?.upperCd) {
                road.exphList[k].exhpAppPcnt = oldRoad.exphList[k].exhpAppPcnt;
                exphTotPcnt += road.exphList[k].exhpAppPcnt;
              } else {
                //이전과 다른 체험실이면 해당 거리 체험인원 제외
                equal = false;
                break;
              }
            }
          } else {
            equal = false;
          }

          return equal;
        });
      }
      exph.exphTotPcnt = exphTotPcnt;
      return equal;
    });
    //동일 체험실이 아닐경우 새로만든 체험실 목록으로
    if (!isEqual) {
      exphList = orgExphList;
    }
  }

  return exphList;
}

function prodScheByPdNo(list) {
  return groupBy(list, 'pdNo');
}

const RECI_DIV_KEY = { 20: 'experPcnt', 10: 'leaderPcnt' };

const PCNT_INFO = {
  experPcnt: {
    key: '',
    mrktnScheSeqNo: 0,
    reciDivCd: '20',
    pesnDivCd: '01',
    genPcnt: 1,
    admfeeDcPcnt: 0,
    incluUserId: '',
    incluNm: '',
    incluGrade: '01',
    incluBirthMonDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
    email: '',
    pdNo: 0,
    pcnt: 1,
  },
  leaderPcnt: {
    key: '',
    mrktnScheSeqNo: 0,
    reciDivCd: '10',
    pesnDivCd: '01',
    genPcnt: 1,
    admfeeDcPcnt: 0,
    leaderId: '',
    leaderNm: '',
    phoneNo: '',
    email: '',
    mbNo: '',
    pdNo: 0,
    pcnt: 1,
  },
};

const INITIAL_DEFAULT_STATE = {
  loadingStatus: true,
  loadingTicket: false,
  loadingPrice: false,
  error: false,
  calendarLoaded: [],
  calendar: [],
  childAgeAgree: false,
  privateAgree: false,
  mktAgree: false,
};

const INITIAL_RESERVE_INFO = {
  productItem: {},
  schedule: [],
  exceDtList: [],
  prodScheList: [],
  basePrice: 0,
  originPrice: 0,
  saleAmt: 0,
  dcPrice: 0,
  ticket: {
    mrktnPdNo: '',
    date: '', //moment(new Date()).add(1, 'd').format('YYYY-MM-DD'),
    mrktnScheSeqNo: 0, //1,
    scheTime: '',
    experPcnt: 0,
    leaderPcnt: 0,
    couponsaleSeq: 0,
  },
  pcntListNm: '체험인원',
  productExphList: [],
  experPcntList: [],
  leaderPcntList: [],
  productPriceList: [],
  orgInfo: {
    hpOrgInfoId: '',
    orgName: '',
    basicAddress: '',
    etcAddress: '',
    grades: [],
    orgType: '01',
  },
  coupon: null,
  productOption: null,
};

const state = {
  ...cloneDeep(INITIAL_DEFAULT_STATE),
  ...cloneDeep(INITIAL_RESERVE_INFO),
};

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, cloneDeep(INITIAL_DEFAULT_STATE), cloneDeep(INITIAL_RESERVE_INFO));
  },
  UPDATE_PRODUCT_ITEM(state, payload) {
    //TO-DO 서버에서 만들어서 가져 오는게 좋을듯
    const productItem = payload;

    const newReserveState = {
      ...cloneDeep(INITIAL_RESERVE_INFO),
      productItem,
    };
    newReserveState.ticket.mrktnPdNo = productItem.mrktnPdNo;
    //newReserveState.ticket.date = productItem.rvpossStartDt;
    //newReserveState.ticket.mrktnScheSeqNo = 1;
    newReserveState.ticket.scheTime = '';
    newReserveState.ticket.experPcnt = 0; //방문인원 표시용
    newReserveState.ticket.leaderPcnt = 0; //방문인원 표시용

    for (let key in newReserveState) {
      state[key] = newReserveState[key];
    }
  },
  UPDATE_RESERVE_INFO(state, payload) {
    for (let key in payload) {
      if (state[key] !== undefined) {
        state[key] = payload[key];
      }
    }
  },
  UPDATE_CALENDAR_INFO(state, payload) {
    const calendar = payload.calendar;
    if (Array.isArray(calendar) && calendar.length > 0) {
      state.calendarLoaded.push(calendar[0].dt); //불러온 달 입력
      state.calendar = [...state.calendar, ...calendar];
    }
  },
  UPDATE_TICKET_INFO(state, payload) {
    //날짜변경이면, 쿠폰 체크
    if (payload.date) {
      //연간회원권만 체험일 기준
      if (state.ticket.couponsaleSeq > 0 && state.coupon?.coupontypDiv === '99') {
        const date = payload.date.replace(/-/g, '');
        if (state.coupon.useStartDt > date || state.coupon.useEndDt < date) {
          state.ticket.couponsaleSeq = 0;
          state.coupon = null;
        }
      }
    }

    for (let key in payload) {
      if (state.ticket[key] !== undefined) {
        state.ticket[key] = payload[key];
      }
    }
  },
  UPDATE_TICKET_PCNT(state, payload) {
    const { target, value, number = value, pesnDivCd } = payload;
    const key = RECI_DIV_KEY[target.reciDivCd];
    const oldPcnt = target.pcnt;
    target.pcnt = value;
    const newPcnt = value;
    state.ticket[key] = newPcnt;
    const targetList = key === 'experPcnt' ? state.experPcntList : state.leaderPcntList;
    /* 체험실별 초기 생년월일 구분 - 어체/진로 */
    //const cDate = new Date();
    //state.productItem.pdDiv == '01'
    //  ? (PCNT_INFO[key].incluBirthMonDate = cDate.getFullYear() - 4 + '-01-01')
    //  : (PCNT_INFO[key].incluBirthMonDate = cDate.getFullYear() + '-' + (cDate.getMonth() + 1) + '-' + cDate.getDate());
    const targetLength = uniq(targetList.map((e) => e.groupKey)).length;

    //정보 입력 리스트
    if (targetLength > value) {
      /* TODO - 삭제, 그룹키를 이용해서 같이 삭제 */
      targetList.splice(newPcnt, targetList.length - newPcnt);
    } else if (targetLength < newPcnt) {
      //신규 인원만큼 루프 돌려서 생성
      for (let i = oldPcnt; i < newPcnt; i++) {
        const personKey = getPersonKey(target, key, i + 1);
        //expProduct를 제거하고, 두개 생성
        //target.scheSeqMap[state.ticket.mrktnScheSeqNo].forEach((seq, i) => {
        const expProduct = target.showExph ? [] : null;
        if (target.showExph) {
          state.productExphList.forEach((info) => {
            expProduct.push({
              pdNo: info.pdNo,
              scheSeqNo: info.scheSeqNo,
              upperCd: '',
              exhpHzCd: '',
              exhpNm: `${info.pdDivNm}(${info.scheSeqNo}회차) - 미선택`,
            });
          });
        }

        targetList.push({
          ...cloneDeep(PCNT_INFO[key]),
          key: personKey + i,
          uniqueId: uniqid(),
          groupKey: personKey,
          pesnDivCd: pesnDivCd || target.pesnPriceList?.[0].pesnDivCd || '01',
          mrktnScheSeqNo: state.ticket.mrktnScheSeqNo,
          pdNo: target.pdNo,
          scheSeqNo: state.ticket.mrktnScheSeqNo, //seq,
          incluGrade: target.gradeList?.[0]?.cd,
          orgPrice: target.price,
          price: target.price,
          gradeList: target.gradeList,
          pesnPriceList: target.pesnPriceList,
          showExph: target.showExph,
          expProduct: expProduct,
          //expProduct: target.scheSeqMap[state.ticket.mrktnScheSeqNo].map((seq) => ({ pdNo: target.pdNo, scheSeqNo: seq })),
        });
        //});
      }
    }
  },
  UPDATE_PCNT_INFO(state, payload) {
    const { event, target } = payload;
    const { name, value } = event.target;

    target[name] = value;
    //복지할인 변경시 가격 변경
    if (name === 'pesnDivCd') {
      target.price = target.pesnPriceList?.find((e) => e.reciDivCd === target.reciDivCd && e.pesnDivCd === value)?.price ?? target.price;
    }
  },
  UPDATE_PCNT_INFOS(state, payload) {
    const { target, datas } = payload;
    for (let key in datas) {
      target[key] = datas[key];
    }
  },
  UPDATE_PCNT_PROD_INFO(state, payload) {
    //const { mrktnScheSeqNo } = payload;
    const ticket = state.ticket;
    const experPcntList = state.experPcntList;
    const leaderPcntList = state.leaderPcntList;
    const productPriceList = state.productPriceList;
    const productExphList = state.productExphList;

    //console.log(state.productPriceList);
    //console.log(state.productExphList);

    let nExperPcntList = null;
    let nLeaderPcntList = null;
    //.filter((e) => !e.showExph);//체험실 선택은 날려버리기
    // .map((e) => {
    //   const price = productPriceList.find((p) => p.pdNo === e.pdNo && p.reciDivCd === '20');
    //   console.log(price);
    //   return {
    //     ...e,
    //   };
    //   // e.expProduct?.forEach((exp, i) => {
    //   //   const price = productPriceList.find((p) => p.pdNo === exp.pdNo && p.reciDivCd === '20');
    //   //   exp.scheSeqNo = price.scheSeqMap[i] || exp.scheSeqNo;
    //   // });
    // });
    //일반 상품이면
    if (state.productItem.mrktnPdYn === 'N') {
      const priceList = productExphList?.[0]?.priceList || productPriceList;
      let experPriceList = null;
      let leaderPriceList = null;

      if (priceList) {
        experPriceList = priceList.find((e) => e.reciDivCd === '20')?.pesnPriceList;
        leaderPriceList = priceList.find((e) => e.reciDivCd === '10')?.pesnPriceList;
      }

      nExperPcntList = experPcntList.map((e) => {
        const expProduct = e.expProduct;
        let pesnDivCd = e.pesnDivCd;
        if (expProduct && expProduct.length > 0) {
          expProduct.forEach((e) => {
            e.scheSeqNo = ticket.mrktnScheSeqNo;
          });
        }

        if (experPriceList) {
          pesnDivCd = experPriceList.find((e) => e.pesnDivCd === pesnDivCd) ? pesnDivCd : experPriceList[0].pesnDivCd;
        }

        return {
          ...e,
          //pdNo: ticket.mrktnPdNo,
          scheSeqNo: ticket.mrktnScheSeqNo,
          mrktnScheSeqNo: ticket.mrktnScheSeqNo,
          pesnPriceList: experPriceList || e.pesnPriceList,
          pesnDivCd: pesnDivCd,
        };
      });

      nLeaderPcntList = leaderPcntList.map((e) => {
        let pesnDivCd = e.pesnDivCd;
        if (leaderPriceList) {
          pesnDivCd = leaderPriceList.find((e) => e.pesnDivCd === pesnDivCd) ? pesnDivCd : leaderPriceList[0].pesnDivCd;
        }

        return {
          ...e,
          scheSeqNo: ticket.mrktnScheSeqNo,
          mrktnScheSeqNo: ticket.mrktnScheSeqNo,
          pesnPriceList: leaderPriceList || e.pesnPriceList,
          pesnDivCd: pesnDivCd,
        };
      });
    } else {
      nExperPcntList = experPcntList.map((e) => {
        const expProduct = e.expProduct;
        if (e.showExph) {
          state.productExphList.forEach((info, i) => {
            const target = expProduct?.[i];
            if (target) {
              target.scheSeqNo = info.scheSeqNo;
              if (!target.exhpHzCd) {
                target.exhpNm = `${info.pdDivNm}(${info.scheSeqNo}회차) - 미선택`;
              }
            }
          });
        }
        return {
          ...e,
          mrktnScheSeqNo: ticket.mrktnScheSeqNo,
          expProduct: expProduct,
        };
      });
      nLeaderPcntList = leaderPcntList;
      // nLeaderPcntList = leaderPcntList.map((e) => {
      //   return {
      //     ...e,
      //     scheSeqNo: ticket.mrktnScheSeqNo,
      //     mrktnScheSeqNo: ticket.mrktnScheSeqNo,
      //   };
      // });
    }

    state.experPcntList = nExperPcntList;
    state.leaderPcntList = nLeaderPcntList;
  },
  UPDATE_ROAD_PCNT(state, { productExph, target, value }) {
    /* 체험실별 초기 생년월일 구분 - 청체/숙련 */
    //const cDate = new Date();
    //state.productItem.pdDiv == '10'
    //  ? (PCNT_INFO.experPcnt.incluBirthMonDate = cDate.getFullYear() - 4 + '-01-01')
    //  : (PCNT_INFO.experPcnt.incluBirthMonDate = cDate.getFullYear() - 6 + '-01-01');

    const prevValue = target.exhpAppPcnt;

    target.exhpAppPcnt = value;
    if (state.ticket.experPcnt !== undefined) {
      const experPcntList = state.experPcntList;
      const oldPcnt = productExph.exphTotPcnt;
      const newPcnt = productExph.roadList.reduce((acc, road) => {
        return road.exphList.reduce((pv, exph) => exph.exhpAppPcnt + pv, 0) + acc;
      }, 0);

      //인원체크
      if (state.productItem.pcntYn === 'Y') {
        if (productExph.samePrsnDiv) {
          const index = oldPcnt > newPcnt ? oldPcnt : newPcnt;
          const personKey = getPersonKey(productExph, 'experPcnt', index);
          const tPerson = experPcntList.find((e) => e.key === personKey);
          if (tPerson) {
            const tProd = tPerson.expProduct.find((e) => e.pdNo === productExph.pdNo && e.scheSeqNo === productExph.scheSeqNo);
            if (tProd) {
              if (oldPcnt > newPcnt) {
                tProd.exhpHzCd = '';
                tProd.exhpNm = `${productExph.pdDivNm}(${productExph.scheSeqNo}회차) - 미선택`;
              } else {
                tProd.exhpHzCd = target.exhpHzCd;
                tProd.exhpNm = `${target.upperNm} -  ${target.exhpHallNm}`;
              }
            }
          }
        }

        if (newPcnt > productExph.pcnt) {
          target.exhpAppPcnt = prevValue; //되돌리기
          return false;
        }
      } else if (oldPcnt > newPcnt) {
        // const personKey = getPersonKey(target, 'experPcnt', oldPcnt);
        // const prevPcntIdx = experPcntList.findIndex((e) => e.groupKey === personKey);
        // if (prevPcntIdx > -1) {
        //   const prevPcnt = experPcntList[prevPcntIdx];
        //   const tProdIdx = prevPcnt.expProduct.findIndex((e) => e.pdNo === productExph.pdNo && e.scheSeqNo === productExph.scheSeqNo);
        //   if (tProdIdx > -1) {
        //     prevPcnt.expProduct.splice(tProdIdx, 1);
        //   }
        //   if (prevPcnt.expProduct.length < 1) {
        //     experPcntList.splice(prevPcntIdx, 1);
        //   }
        // } else {
        // }
        const lastIndex = experPcntList.findLastIndex((e) => e.exhpHzCd === target.exhpHzCd); //TO-DO 폴리필 필요한지 확인;
        if (lastIndex > -1) {
          experPcntList.splice(lastIndex, 1);
        }
      } else if (oldPcnt < newPcnt) {
        let lastIndex = experPcntList.length; //experPcntList.findIndex((e) => e.exhpHzCd > target.exhpHzCd);
        //lastIndex = lastIndex === -1 ? experPcntList.length : lastIndex;
        const pcntPrice = productExph.priceList?.find((e) => e.reciDivCd === PCNT_INFO.experPcnt.reciDivCd);
        const price = pcntPrice?.price;

        const addList = [];
        for (let i = oldPcnt; i < newPcnt; i++) {
          const personKey = getPersonKey(target, 'experPcnt', i + 1);
          //const prevPcnt = experPcntList.find((e) => e.groupKey === personKey);
          if (false && prevPcnt) {
            prevPcnt.expProduct.push({
              pdNo: productExph.pdNo,
              scheSeqNo: productExph.scheSeqNo,
              upperCd: target.upperCd,
              exhpHzCd: target.exhpHzCd,
              exhpNm: `${target.upperNm} -  ${target.exhpHallNm}`,
            });
          } else {
            addList.push({
              ...cloneDeep(PCNT_INFO.experPcnt),
              key: personKey,
              uniqueId: uniqid(),
              groupKey: personKey,
              pesnDivCd: pcntPrice?.pesnPriceList?.[0].pesnDivCd || '01',
              incluGrade: pcntPrice?.gradeList[0]?.cd,
              mrktnScheSeqNo: state.ticket.mrktnScheSeqNo,
              pdNo: productExph.pdNo,
              scheSeqNo: productExph.scheSeqNo,
              exhpHzCd: target.exhpHzCd,
              exhpNm: `${target.upperNm} -  ${target.exhpHallNm}`,
              orgPrice: price,
              price: price,
              gradeList: pcntPrice?.gradeList,
              pesnPriceList: pcntPrice?.pesnPriceList,
              showExph: true,
              expProduct: [
                {
                  pdNo: productExph.pdNo,
                  scheSeqNo: productExph.scheSeqNo,
                  exhpHzCd: target.exhpHzCd,
                  upperCd: target.upperCd,
                  exhpNm: `${target.upperNm} -  ${target.exhpHallNm}`,
                },
              ],
            });
          }
        }
        experPcntList.splice(lastIndex, 0, ...addList);
      }

      productExph.exphTotPcnt = newPcnt;
      state.ticket.experPcnt += newPcnt - oldPcnt;
    }
  },
  UPDATE_MRKTN_ROAD_PCNT(state, { productExph, target, value }) {
    if (target.exhpHzCd) {
      const road = productExph.roadList.find((e) => e.exhpHzCd === value.upperCd);
      const oldExhp = road?.exphList.find((e) => e.exhpHzCd == target.exhpHzCd);
      if (oldExhp) {
        oldExhp.exhpAppPcnt -= 1;
        productExph.exphTotPcnt -= 1;
      }
    }

    value.exhpAppPcnt += 1;
    productExph.exphTotPcnt += 1;

    target.exhpHzCd = value.exhpHzCd;
    target.exhpNm = `${value.upperNm} -  ${value.exhpHallNm}`;
    target.upperCd = value.upperCd;
    target.pdNo = value.pdNo;
    target.scheSeqNo = value.scheSeqNo;

    //console.log(productExph, target, value);
  },
  CREATE_FIXED_PCNT(state, { target, info, number, showExph }) {
    const personKey = getPersonKey(info, target, number);
    const targetList = target === 'experPcnt' ? state.experPcntList : state.leaderPcntList;
    const person = targetList.find((e) => e.key === personKey);
    if (!person) {
      state.ticket[target] = number > state.ticket[target] ? number : state.ticket[target];
      targetList.push({
        ...cloneDeep(PCNT_INFO[target]),
        key: personKey,
        uniqueId: uniqid(),
        groupKey: personKey,
        mrktnScheSeqNo: state.ticket.mrktnScheSeqNo,
        //incluGrade: info.gradeList?.[0]?.cd,
        //gradeList: info.gradeList,
        //pesnPriceList: info.pesnPriceList,
        pdNo: info.pdNo,
        showExph: showExph,
        expProduct: [],
        //expProduct: [{ pdNo: info.pdNo, scheSeqNo: '', exhpHzCd: '', exhpNm: info.pdDivNm }],
      });
    } else {
      //person.expProduct.push({ pdNo: info.pdNo, scheSeqNo: '', exhpHzCd: '', exhpNm: info.pdDivNm });
    }
  },
  UPDATE_FIXED_PCNT(state, { type, info, number }) {
    const target = RECI_DIV_KEY[info.reciDivCd] || 'experPcnt';
    const targetList = target === 'experPcnt' ? state.experPcntList : state.leaderPcntList;
    const personKey = getPersonKey(info, target, number);
    const tPerson = targetList.find((e) => e.key === personKey);
    if (tPerson) {
      if (type === 'price') {
        tPerson.incluGrade = info.gradeList?.[0]?.cd;
        tPerson.gradeList = info.gradeList;
        tPerson.pesnPriceList = info.pesnPriceList;
        //const tIdx = tPerson.expProduct?.findIndex((e) => e.pdNo === info.pdNo);
        //if (tIdx > -1) {
        //const exhpNm = tPerson.expProduct[tIdx].exhpNm;
        //tPerson.expProduct.splice(tIdx, 1, ...info.scheSeqMap[state.ticket.mrktnScheSeqNo].map((seq) => ({ pdNo: info.pdNo, scheSeqNo: seq, exhpNm })));
        //}
      } else {
        //const pcntPrice = info.priceList?.find((e) => e.reciDivCd === PCNT_INFO.experPcnt.reciDivCd);
        //tPerson.incluGrade = pcntPrice?.gradeList[0]?.cd;
        //tPerson.gradeList = pcntPrice?.gradeList;
        //tPerson.pesnPriceList = pcntPrice?.pesnPriceList;
        const tIdx = tPerson.expProduct?.findIndex((e) => e.pdNo === info.pdNo && e.scheSeqNo === info.scheSeqNo);
        if (tIdx > -1) {
          //tPerson.expProduct.splice(tIdx, 1);
        } else {
          tPerson.expProduct.push({
            pdNo: info.pdNo,
            scheSeqNo: info.scheSeqNo,
            upperCd: '',
            exhpHzCd: '',
            exhpNm: `${info.pdDivNm}(${info.scheSeqNo}회차) - 미선택`,
          });
        }
      }
    }
  },
  CREATE_GRP_EXPER_PCNT(state, payloadList) {
    if (payloadList) {
      const allExperPcntList = [];
      payloadList.forEach((payload, j) => {
        if (payload) {
          const pcnt = 15; //체험자 기본 인원
          const key = RECI_DIV_KEY[payload.reciDivCd];
          //const sPrice = state.productPriceList.find((e) => e.reciDivCd === payload.reciDivCd);

          const sPrice = state.productPriceList.find((e) => e.reciDivCd === payload.reciDivCd && e.pdNo === payload.pdNo);
          sPrice.pcnt = pcnt;

          state.ticket[key] = pcnt;
          const experPcntList = payload.pesnPriceList.map((pl, i) => {
            const personKey = getPersonKey(payload, key, i);
            return {
              key: personKey,
              ...pl,
              groupKey: personKey,
              orgPrice: pl.originPrice,
              //price: pl.price,
              pcnt: i === 0 ? pcnt : 0,
              pdNo: payload.pdNo,
              mrktnScheSeqNo: state.ticket.mrktnScheSeqNo,
              scheSeqNo: state.ticket.mrktnScheSeqNo,
              //expProduct: payload.scheSeqMap[state.ticket.mrktnScheSeqNo].map((seq) => ({ pdNo: payload.pdNo, scheSeqNo: seq })),
            };
          });
          allExperPcntList.push(...experPcntList);
        }
      });
      state.experPcntList = allExperPcntList;
    }
  },
  UPDATE_GRP_EXPER_PRICE_PCNT(state, payload) {
    let invalidPcnt = 0;
    const filteredList = state.experPcntList.filter((e) => {
      if (payload.pesnPriceList.find((pl) => pl.pesnDivCd === e.pesnDivCd)) {
        return true;
      } else {
        invalidPcnt += e.pcnt;
        return false;
      }
    });

    const addPcntList = payload.pesnPriceList
      .filter((e) => {
        if (state.experPcntList.find((pl) => pl.pesnDivCd === e.pesnDivCd)) {
          return false;
        } else {
          return true;
        }
      })
      .map((pl, i) => {
        const personKey = getPersonKey(payload, 'experPcnt', parseInt(Math.random() * 10000));
        return {
          key: personKey,
          ...pl,
          groupKey: personKey,
          orgPrice: pl.originPrice,
          pcnt: 0,
          pdNo: payload.pdNo,
          mrktnScheSeqNo: state.ticket.mrktnScheSeqNo,
          scheSeqNo: state.ticket.mrktnScheSeqNo,
        };
      });
    if (filteredList[0]) {
      filteredList[0].pcnt += invalidPcnt;
    } else {
      addPcntList[0].pcnt += invalidPcnt + 15;
    }
    state.experPcntList = [...filteredList, ...addPcntList];
  },
  UPDATE_GRP_EXPER_PCNT(state, payload) {
    const { target, value } = payload;
    const pcnt = value;
    target.pcnt = pcnt;
    state.ticket.experPcnt = pcnt;
    const prevPcnt = state.experPcntList.reduce((a, e) => a + e.pcnt, 0);

    if (pcnt > prevPcnt) {
      state.experPcntList[0].pcnt += pcnt - prevPcnt;
    } else {
      let remain = prevPcnt - pcnt;
      let targetIndex = 0;
      while (remain > 0) {
        if (state.experPcntList[targetIndex].pcnt > 0) {
          state.experPcntList[targetIndex].pcnt--;
          remain--;
        } else {
          targetIndex++;
          if (!state.experPcntList[targetIndex]) {
            break;
          }
        }
      }
    }
  },
  UPDATE_GRP_EXPER_SALE_PCNT(state, payload) {
    const { target, value } = payload;
    const normalPcnt = state.experPcntList.find((e) => e.pesnDivCd === '01');

    if (normalPcnt) {
      const gap = value - target.pcnt;

      //증가
      if (gap > 0) {
        if (normalPcnt.pcnt >= gap) {
          normalPcnt.pcnt -= gap;
          target.pcnt = value;
        }
      } else {
        normalPcnt.pcnt -= gap;
        target.pcnt = value;
      }
    }
  },
  UPDATE_GRP_ORG_INFO(state, payload) {
    if (payload) {
      const grades = payload.grades;

      delete payload.grades;
      for (let key in payload) {
        state.orgInfo[key] = payload[key];
      }

      if (grades) {
        state.orgInfo.grades = [...grades];
      }
    }
  },
  CLEAR_PCNT(state) {
    state.ticket.experPcnt = 0;
    state.ticket.leaderPcnt = 0;
    state.productPriceList.forEach((e) => {
      e.pcnt = 0;
    });
    state.experPcntList = [];
    state.leaderPcntList = [];
  },
  REMOVE_PCNT(state, pcnt) {
    if (pcnt.reciDivCd === '20') {
      state.experPcntList = state.experPcntList.filter((e) => e.uniqueId !== pcnt.uniqueId);

      if (pcnt.expProduct && pcnt.expProduct.length > 0) {
        pcnt.expProduct.forEach((e) => {
          const exphObj = state.productExphList.find((exph) => exph.pdNo === e.pdNo && exph.scheSeqNo === e.scheSeqNo);
          if (exphObj) {
            const road = exphObj.roadList.find((road) => road.exhpHzCd === e.upperCd);
            const exph = road?.exphList.find((exph) => exph.exhpHzCd === e.exhpHzCd);
            if (exph) {
              exphObj.exphTotPcnt -= 1;
              exph.exhpAppPcnt -= 1;
            }
          }
        });
      }
    } else {
      state.leaderPcntList = state.leaderPcntList.filter((e) => e.uniqueId !== pcnt.uniqueId);
    }

    if (state.productPriceList && state.productPriceList.length > 0) {
      const price = state.productPriceList.find((e) => e.reciDivCd === pcnt.reciDivCd);
      price.pcnt -= pcnt.pcnt;
    }
  },
  UPDATE_LOADING_STATUS(state, newLoadingStatus) {
    state.loadingStatus = newLoadingStatus;
  },
  UPDATE_LOADING_TICKET(state, newLoadingTicket) {
    state.loadingTicket = newLoadingTicket;
  },
  UPDATE_LOADING_PRICE(state, newLoadingPrice) {
    state.loadingPrice = newLoadingPrice;
  },
};

const actions = {
  async getProduct({ commit, state }, { id, pgDiv, dt, d, t }) {
    const rtnOpt = {};
    commit('UPDATE_LOADING_STATUS', true);
    try {
      const res = await productAPi.getProduct(id, pgDiv, dt, undefined, d, t);
      const resData = res.data.response;
      const product = resData.product;
      const prodScheList = resData.prodScheList;
      const productPriceList = resData.productPriceList;
      const productExphList = resData.productExphList;
      const productPriceListNotShow = (resData.productSamePriceList || []).map((e) => ({ ...e, hide: true }));
      const exceDtList = resData.exceDtList;
      const basePrice = product?.basePrice || 0;
      const reserveInfo = {
        schedule: resData.schedule,
        prodScheList: prodScheByPdNo(prodScheList),
        productPriceList: setPriceList([...productPriceList, ...productPriceListNotShow], product.pcntYn),
        productExphList: setExphList(productExphList, product),
        exceDtList: exceDtList,
        basePrice: basePrice,
      };

      commit('UPDATE_PRODUCT_ITEM', product);
      commit('UPDATE_RESERVE_INFO', reserveInfo);

      if (product.pcntYn === 'Y') {
        //예약자 정보 입력 생성
        product.mstrPdList.forEach((mPd) => {
          const showExph = mPd.capaPcntType === '01';
          //체험자
          const experPcnt = mPd.exprCapaPcnt || 0;
          const leaderPcnt = mPd.leaderCapaPcnt || 0;
          for (let i = 1; i <= experPcnt; i++) {
            commit('CREATE_FIXED_PCNT', { info: mPd, target: 'experPcnt', number: i, showExph });

            productExphList.forEach((exph) => {
              commit('UPDATE_FIXED_PCNT', { type: 'exph', info: cloneDeep(exph), number: i });
            });
          }
          //보호자
          for (let i = 1; i <= leaderPcnt; i++) {
            commit('CREATE_FIXED_PCNT', { info: mPd, target: 'leaderPcnt', number: i });
          }
        });
        productPriceList.forEach((price) => {
          for (let i = 1; i <= price.pcnt; i++) {
            commit('UPDATE_FIXED_PCNT', { type: 'price', info: cloneDeep(price), number: i });
          }
        });

        //방문인원 타이틀 변경
        /*if (product.mstrPdList.length > 1) {
          const pdNo = productPriceList[0]?.pdNo;
          const mstrPd = product.mstrPdList.find((e) => e.pdNo === pdNo);
          if (mstrPd) {
            commit('UPDATE_RESERVE_INFO', { pcntListNm: mstrPd.pdDivNm + ' 인원' || '방문인원' });
          }
        }*/
      }
      rtnOpt.bExphRequest = resData.bExphRequest;

      if (pgDiv === 'G') {
        const experPrice = state.productPriceList.filter((e) => e.reciDivCd === '20');
        commit('CREATE_GRP_EXPER_PCNT', experPrice);
        const leaderPrice = state.productPriceList.find((e) => e.reciDivCd === '10');
        if (leaderPrice) {
          const pesnDivCd = leaderPrice.pesnPriceList?.find((e) => e.pesnDivCd === '07') ? '07' : null;
          commit('UPDATE_TICKET_PCNT', { target: leaderPrice, value: 1, pesnDivCd: pesnDivCd });
        }
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
    commit('UPDATE_LOADING_STATUS', false);

    return rtnOpt;
  },
  async getProductSchedule({ commit, state }, { id, pgDiv, dt, seq, d, t, allNew }) {
    commit('UPDATE_LOADING_TICKET', true);
    try {
      const res = await productAPi.getProduct(id, pgDiv, dt, seq, d, t);
      const resData = res.data.response;
      const product = resData.product;
      const schedule = resData.schedule;
      const reserveInfo = {
        schedule: schedule,
        prodScheList: prodScheByPdNo(resData.prodScheList),
      };
      const currScheSeq = state.ticket.mrktnScheSeqNo;
      const isExist = schedule?.find((e) => e.mrktnScheSeqNo === currScheSeq);
      if (!isExist && schedule?.length > 0) {
        commit('UPDATE_TICKET_INFO', { mrktnScheSeqNo: schedule[0].mrktnScheSeqNo });
        commit('UPDATE_PCNT_PROD_INFO', { mrktnScheSeqNo: schedule[0].mrktnScheSeqNo });
      }

      // if (product.pcntYn !== 'Y') {
      const productPriceListNotShow = (resData.productSamePriceList || []).map((e) => ({ ...e, hide: true }));
      reserveInfo.productPriceList = setPriceList([...resData.productPriceList, ...productPriceListNotShow], product.pcntYn, state.productPriceList);
      reserveInfo.productExphList = setExphList(resData.productExphList, product, allNew ? null : state.productExphList);

      //체험실 선택 인원이 변경체크, 단체는 체험실 선택이 없으니 괜찮을듯
      if (product.pcntYn !== 'Y') {
        reserveInfo.productExphList.every((e, i) => {
          if (state.productExphList[i]?.exphTotPcnt != e.exphTotPcnt) {
            //다르면 해당 참가자 초기화
            commit('CLEAR_PCNT');
            return false;
          }
          return true;
        });
      }

      if (pgDiv === 'G') {
        const experPrice = resData.productPriceList.find((e) => e.reciDivCd === '20');
        commit('UPDATE_GRP_EXPER_PRICE_PCNT', experPrice);
      }

      commit('UPDATE_RESERVE_INFO', reserveInfo);
      commit('UPDATE_PCNT_PROD_INFO', {});
    } catch (e) {
      console.log(e);
    }
    commit('UPDATE_LOADING_TICKET', false);
  },
  async getCalendar({ commit, state }, rDt) {
    //해당 월 첫번째 요청만 요청
    if (state.calendarLoaded.indexOf(rDt) === -1) {
      const data = await getCalendarDay(rDt);
      //비동기이므로 넣기 직전 한번더 체크
      if (data.success && state.calendarLoaded.indexOf(rDt) === -1) {
        commit('UPDATE_CALENDAR_INFO', { calendar: data.response });
      }
    }
  },
  calcPrice: debounce(async function ({ commit, state, getters }, groupPersDiv = '02') {
    //인원이 있을때만,
    if (state.experPcntList.length > 0 || state.leaderPcntList?.length > 0) {
      commit('UPDATE_LOADING_PRICE', true);
      const booking = { ...getters.reserveInfo, groupPersDiv };
      const data = await calculatePrice({ bookingList: [booking] });
      if (data.success) {
        const orderPrice = data.response.orderPrice;
        const price = {
          originPrice: orderPrice.totOriginPrice,
          saleAmt: orderPrice.totSaleAmt,
          dcPrice: orderPrice.totDcPrice,
        };

        commit('UPDATE_RESERVE_INFO', price);
      }
      commit('UPDATE_LOADING_PRICE', false);
    } else {
      commit('UPDATE_RESERVE_INFO', {
        originPrice: state.basePrice,
        saleAmt: state.basePrice,
        dcPrice: 0,
      });
    }
  }, 300),
  resetReserveInfo({ commit }) {
    commit('RESET_STATE');
  },
  editReserveInfo({ commit }, info) {
    commit('UPDATE_RESERVE_INFO', info);
  },
  changeTicketInfo({ commit }, infos) {
    commit('UPDATE_TICKET_INFO', infos);
  },
  changeScheSeqNo({ commit }, value) {
    commit('UPDATE_TICKET_INFO', { mrktnScheSeqNo: value });
    commit('UPDATE_PCNT_PROD_INFO', { mrktnScheSeqNo: value });
  },
  changeTicketPcnt({ commit }, { pgDiv, target, value }) {
    if (pgDiv === 'P') {
      commit('UPDATE_TICKET_PCNT', { target, value });
    } else if (pgDiv === 'G') {
      //인솔자,보호자
      if (target.reciDivCd === '10') {
        commit('UPDATE_TICKET_PCNT', { target, value });
      } else {
        commit('UPDATE_GRP_EXPER_PCNT', { target, value });
      }
    }
  },
  changePcntInfo({ commit }, info) {
    commit('UPDATE_PCNT_INFO', info);
  },
  changePcntInfos({ commit }, infos) {
    commit('UPDATE_PCNT_INFOS', infos);
  },
  changeGrpSalePcntInfo({ commit }, { target, value }) {
    commit('UPDATE_GRP_EXPER_SALE_PCNT', { target, value });
  },
  changeOrgInfo({ commit }, values) {
    commit('UPDATE_GRP_ORG_INFO', values);
  },
  changeMrktnRoadPcnt({ commit }, { productExph, target, value }) {
    commit('UPDATE_MRKTN_ROAD_PCNT', { productExph, target, value });
  },
  removePcnt({ commit }, pcnt) {
    commit('REMOVE_PCNT', pcnt);
  },
  clearPcnt({ commit }) {
    commit('CLEAR_PCNT');
  },
};

const getters = {
  reserveInfo(state, getter) {
    //체험실 별 인원
    const rvExhpAppList = state.productExphList
      ?.map((exphList) => {
        return exphList.roadList?.map((road) => road.exphList.filter((exph) => exph.exhpAppPcnt > 0)).flat();
      })
      .flat();
    const mrktnPdYn = state.productItem.mrktnPdYn;
    const orgExperPcntList = state.experPcntList;
    const orgLeaderPcntList = state.leaderPcntList;
    let experPcntList = [];
    let leaderPcntList = [];
    const prodScheList = state.prodScheList;

    if (mrktnPdYn === 'Y') {
      orgExperPcntList.forEach((e) => {
        //showExph 가 있을때만 expProduct 가 있음
        if (e.expProduct && e.expProduct.length > 0) {
          e.expProduct.forEach((exp) => {
            const tempPcnt = { ...e, ...exp };
            delete tempPcnt.expProduct;
            experPcntList.push(tempPcnt);
          });
        } else {
          const tProdScheList = prodScheList[e.pdNo]?.filter((t) => t.mrktnScheSeqNo === e.mrktnScheSeqNo);
          if (tProdScheList && tProdScheList.length > 0) {
            for (let i = 0; i < tProdScheList.length; i++) {
              experPcntList.push({ ...e, scheSeqNo: tProdScheList[i].scheSeqNo });
            }
          } else {
            experPcntList.push(e);
          }
        }
      });
      leaderPcntList = orgLeaderPcntList;
      // TODO: 왜 마케팅 보호자 회차를 0으로??
      // leaderPcntList = orgLeaderPcntList.map((e) => ({ ...e, scheSeqNo: 0 }));
    } else {
      experPcntList = orgExperPcntList;
      leaderPcntList = orgLeaderPcntList;
    }

    return cloneDeep({
      //bundleRvNo: '',
      //pdRvNo: '',
      cartNo: uniqid(),
      expVisitRvdt: state.ticket.date,
      mrktnPdNo: state.ticket.mrktnPdNo,
      mrktnPdNm: state.productItem.mrktnPdNm,
      pdDiv: state.productItem.mstrPdList?.[0]?.pdDiv,
      mrktnScheSeqNo: state.ticket.mrktnScheSeqNo,
      mrktnScheSeqNm: state.schedule.find((e) => e.mrktnScheSeqNo === state.ticket.mrktnScheSeqNo)?.mrktnScheSeqNm || state.ticket.mrktnScheSeqNo + '회차',
      scheTime: state.ticket.scheTime,
      mrktnPdYn: state.productItem.mrktnPdYn,
      pcntYn: state.productItem.pcntYn || 'N',
      price: state.productItem.price,
      //groupPersDiv: '02',
      rvExhpAppList: rvExhpAppList,
      // rvPesnList: [
      //   {
      //     scheSeqNo: '1',
      //     reciDivCd: '20',
      //     pesnDivCd: '01',
      //     genPcnt: 1,
      //     admfeeDcPcnt: 0,
      //   },
      // ],
      includeList: experPcntList, //state.experPcntList,
      leaderList: leaderPcntList, //state.leaderPcntList,
      //includeList: getFlatPcnt(state.experPcntList), //평탄화
      //leaderList: getFlatPcnt(state.leaderPcntList),
      multiDiscountYn: '',
      originPrice: getter.originPrice,
      saleAmt: getter.saleAmt,
      orgInfo: state.orgInfo,
      couponsaleSeq: state.ticket.couponsaleSeq,
    });
  },
  mstrPdList(state) {
    return state.productItem?.mstrPdList || [];
  },
  experPcnt(state) {
    return state.experPcntList.reduce((a, e) => e.pcnt + a, 0);
  },
  originPrice(state) {
    let orgPrice = 0;
    if (state.productItem?.pcntYn === 'Y') {
      orgPrice = state.productItem.price;
    } else {
      orgPrice = state.originPrice;
    }
    // else {
    //   const { experPcntList, leaderPcntList } = state;
    //   orgPrice += experPcntList.reduce((a, e) => e.orgPrice * e.pcnt + a, 0);
    //   orgPrice += leaderPcntList.reduce((a, e) => e.orgPrice * e.pcnt + a, 0);
    // }
    return orgPrice;
  },
  saleAmt(state) {
    let price = 0;
    if (state.productItem?.pcntYn === 'Y') {
      price = state.productItem.price;
    } else {
      price = state.saleAmt;
    }
    // else {
    //   state.experPcntList.forEach((pcnt) => (price += pcnt.pcnt * pcnt.price));
    //   state.leaderPcntList.forEach((pcnt) => (price += pcnt.pcnt * pcnt.price));
    // }
    return price;
  },
  chkChildAge(state, getter) {
    return Boolean(getter.mstrPdList.find((e) => e.pdDiv === '01'));
  },
  chkYouthAge(state, getter) {
    return Boolean(getter.mstrPdList.find((e) => e.pdDiv === '02'));
  },
  chkSkillAge(state, getter) {
    return Boolean(getter.mstrPdList.find((e) => e.pdDiv === '10'));
  },
  isYouthOrSkill(state, getter) {
    return Boolean(getter.mstrPdList.find((e) => e.pdDiv === '02' || e.pdDiv === '10'));
  },
};

const reserveModule = { namespaced: true, state, mutations, actions, getters };

export default reserveModule;
